import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const StartAdornment = styled(Text)`
  margin-top: 2px !important;
`
